<div class="trust-trustees-search">
    <form @submit.prevent="submit_trust_trustees">
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="trust_number" class="fw-bold text-xs">Trust Number</label>
                <input type="text" v-model="form.trust_number" class="form-control text-xs rounded-small p-3 shadow-sm" id="trust_number" placeholder="000000/YYYY" required>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="masters_office" class="fw-bold text-xs">Master's Office</label>
                <input type="text" v-model="form.masters_office" class="form-control text-xs rounded-small p-3 shadow-sm" id="masters_office" required placeholder="eg. Bloemfontein">
            </div>
        </div>
        <div class="d-flex justify-content-end my-2">
            <button type="submit" class="btn btn-primary-color rounded-pill text-xs">
                Search
            </button>
        </div>
    </form>
</div>